import React from "react";
import styled from 'styled-components';
import Parser from "html-react-parser";

export const CarouselItem43 = ({item}) => {
    return (
        <CarouselItemDiv43>
            <div className="carousel-item-individual">
                {Parser(item)}
            </div>
        </CarouselItemDiv43>
    )
}


const CarouselItemDiv43 = styled.div`
    .carousel-item-individual {
        align-items: center;
        height: 60vmin;
        width: 80vmin;
        margin: 0 0 0 0;
        overflow: hidden;
        border-radius: 15px;
    }
    
    img {
        overflow: hidden;
        height: auto;
        border-radius: 15px;
    }
`
